// NPM Imports
import { get, put, post, deleteApi } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

// Destructuring
const { APIS } = API_ENDPOINTS;

export const getPipelineListService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.PIPELINES}`)
      .then(response => {
        resolve(response.pipelines);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getPipeLineLaneConfigDetailsService = pipelineId =>
  new Promise((resolve, reject) => {
    get(`${APIS.PIPELINE}/${pipelineId}/lanes`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(`pipelineServices => export const getPipeLineLaneConfigDetailsService = () =>
        => ${error}`);
        reject(error);
      });
  });

export const updatePipeLineLaneConfigDetailsService = (pipelineId, data) =>
  new Promise((resolve, reject) => {
    post(`${APIS.PIPELINE}/${pipelineId}/lanes`, data)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(`pipelineServices => export const updatePipeLineLaneConfigDetailsService = () =>
        => ${error}`);
        reject(error);
      });
  });

export const getAllEventsService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.PIPELINES}/events`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(`pipelineServices => export const getAllEventsService = () =>
        => ${error}`);
        reject(error);
      });
  });

export const getSwimLandDataByIdService = (pipelineId, laneId, pageNumber) =>
  new Promise((resolve, reject) => {
    get(
      `${APIS.PIPELINE}/${pipelineId}/lanes/${laneId}/documents?page_num=${pageNumber}&page_size=20`,
    )
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(`pipelineServices => fetchAllUsers => ${error}`);
        reject(error);
      });
  });

export const swimLaneDragandDropService = (pipelineId, docId, dataTo) =>
  new Promise((resolve, reject) => {
    put(`${APIS.PIPELINE}/${pipelineId}/lane-transition/${docId}`, {
      lane_id: dataTo,
    })
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(`pipelineServices => fetchAllUsers => ${error}`);
        reject(error);
      });
  });

export const deleteLaneConfigurationTranstionService = (
  pipelineId,
  laneId,
  replacementLaneId,
) =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.PIPELINE}/${pipelineId}/lanes/${laneId}`, {
      replacement_lane_id: replacementLaneId,
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getPipelineSearchTermService = (pipelineId, searchTerm) =>
  new Promise((resolve, reject) => {
    get(`${APIS.PIPELINE}/${pipelineId}/documents/search?term=${searchTerm}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getPipelineSwimlaneCardsCounts = pipelineId =>
  new Promise((resolve, reject) => {
    get(`${APIS.PIPELINE}/${pipelineId}/documents/aggregate`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const addNewPipelineService = payload =>
  new Promise((resolve, reject) => {
    post(`${APIS.PIPELINES}`, payload)
      .then(response => {
        resolve(response.pipeline);
      })
      .catch(error => {
        reject(error);
      });
  });

export const editPipelineService = payload =>
  new Promise((resolve, reject) => {
    post(`${APIS.PIPELINES}`, payload)
      .then(response => {
        resolve(response.pipeline);
      })
      .catch(error => {
        reject(error);
      });
  });

export const deletePipelineService = payload =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.PIPELINES}/${payload.pipelineId}`, {
      id: payload.alternativePipelineId,
    })
      .then(response => {
        resolve(response.pipeline);
      })
      .catch(error => {
        reject(error);
      });
  });

export const moveDocToAnotherPipelineService = payload =>
  new Promise((resolve, reject) => {
    put(`${APIS.PIPELINE}/${payload.moveToPipelineId}/doc/${payload.docId}`)
      .then(response => {
        resolve(response.pipeline);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAllPipelineRoutingsService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.PIPELINES}/routing-rules`)
      .then(response => {
        resolve(response.routing_rules);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getTemplatesForRoutingRuleService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.DOCUMENT_TEMPLATES}?status=ACTIVE&count=50`)
      .then(response => {
        resolve(response.Templates);
      })
      .catch(error => {
        reject(error);
      });
  });

export const saveNewRoutingRuleService = payload =>
  new Promise((resolve, reject) => {
    post(`${APIS.PIPELINES}/routing-rules`, payload)
      .then(response => {
        resolve(response.routing_rule);
      })
      .catch(error => {
        reject(error);
      });
  });

export const deleteRoutingRuleService = id =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.PIPELINES}/routing-rules/${id}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const createPipelineLaneJobService = (pipelineId, payload) =>
  new Promise((resolve, reject) => {
    post(`${APIS.PIPELINE}/${pipelineId}/lane-jtbds`, payload)
      .then(response => {
        resolve(response.lane_jtbds);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updatePipelineLaneJobService = (pipelineId, jobId, payload) =>
  new Promise((resolve, reject) => {
    put(`${APIS.PIPELINE}/${pipelineId}/lane-jtbds/${jobId}`, payload)
      .then(response => {
        resolve(response.lane_jtbds);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getPipelineLaneJobService = pipelineId =>
  new Promise((resolve, reject) => {
    get(`${APIS.PIPELINE}/${pipelineId}/lane-jtbds`)
      .then(response => {
        resolve(response.lane_jtbds);
      })
      .catch(error => {
        reject(error);
      });
  });

export const deletePipelineLaneJobService = (pipelineId, jobId) =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.PIPELINE}/${pipelineId}/lane-jtbds/${jobId}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getPipelineReminderEventsService = () =>
  new Promise((resolve, reject) => {
    get(APIS.REMINDER_EVENTS)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getPipelineReminderSettingsService = pipelineID =>
  new Promise((resolve, reject) => {
    get(`${APIS.REMINDER_SETTINGS_PIPELINE}${pipelineID}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updatePipelineReminderSettingsService = (data, pipelineID) =>
  new Promise((resolve, reject) => {
    post(`${APIS.REMINDER_SETTINGS_PIPELINE}${pipelineID}`, data)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(`pipelineServices => export const updatePipelineReminderSettingsService = () =>
        => ${error}`);
        reject(error);
      });
  });
